/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * This file is for all shared styles across
 * ApplicationsList, EventsList, and StudentList.
 */

import styled from "styled-components";

import {
  getTheme,
  mergeStyles,
  FontSizes,
  IButtonStyles,
  IDetailsListStyles,
  ISpinnerStyles,
  IStackStyles,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

/**
 * Styles used for Details List
 */
export const detailListStyles: Partial<IDetailsListStyles> = {
  root: {
    borderRadius: "8px",
    height: "100%",
    padding: "23px",
    paddingTop: "0",
  },
};

/**
 * Styles for the icon button used within the modal
 */
export const iconButtonStyles: IButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    margin: "0px 2px 20px auto",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

/**
 * Styled modal content container (div)
 */
export const ModalContent = styled.div`
  z-index: 1;
  width: 100%;
  margin-top: 1rem;
  padding-right: 1rem;
`;

/**
 * Styled modal header component within detail
 */
export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
`;

/**
 * Styles for header of the modal
 */
export const modalHeaderStyles: Partial<ITextStyles> = {
  root: {
    fontSize: FontSizes.xLarge,
    flexGrow: 2,
  },
};

/**
 * Styles for detail modal
 */
export const modalStyles = mergeStyles({
  display: "flex",
  flexFlow: "column nowrap",
  alignItems: "stretch",
  width: "56.25rem",
  minHeight: 600,
  maxHeight: "80%",
  padding: "24px",
  position: "relative",
});

/**
 * Styles used for loading spinner
 */
export const spinnerStyles: ISpinnerStyles = {
  root: {
    marginTop: 32,
  },
};

/**
 * Styled span for ID column
 */
export const StyledSpan = styled.span`
  color: #0078d7;
  cursor: pointer;
`;

export const highActivitiesEventsDetailsHeaderStyles: Partial<IDetailsListStyles> = {
  root: {
    [".ms-DetailsHeader"]: { "padding-top": 0 },
  },
};

export const filterButtonStyles: IStackStyles = {
  root: {
    marginTop: "10px",
    display: "block",
  },
};
